interface LanguageMap {
  ref?: string;
  fi?: string;
  en?: string;
  se?: string;
  fr?: string;
  de?: string;
  es?: string;
  et?: string;
}
export const getLocalizedText = (
  langObject: LanguageMap | null | undefined,
  lang: string,
  fallBack?: string | null
): string => {
  if (langObject == null) return fallBack ?? "";

  return (
    langObject?.[lang as keyof LanguageMap] ||
    langObject?.en ||
    langObject?.fi ||
    Object.values(langObject)[0] ||
    fallBack ||
    ""
  );
};
